  <ng-container *ngIf="loading; else notLoading">
      <div class="flex justify-center items-center h-full" [style.height.px]="height">
        <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
      </div>
    </ng-container>

    <ng-template #notLoading >
      <ng-container *ngIf="error; else content">
        <ng-container 
          *ngTemplateOutlet="customErrorTpl || defaultErrorTpl">
        </ng-container>
      </ng-container>
      <ng-template #content>
        <ng-content></ng-content>
      </ng-template>
    </ng-template>

    <ng-template #defaultErrorTpl >
    <div class="flex items-center justify-center p-6 bg-red-100 rounded-xl m-4">
      <div class="flex items-center gap-3">
        <div
          class="w-6 h-6 bg-red-600 rounded-full flex items-center justify-center text-base font-bold text-white flex-shrink-0"
        >
          !
        </div>
        <div class="text-sm font-medium leading-normal text-red-900">
          Une erreur s'est produite lors du chargement des données.
        </div>
      </div>
    </div>
    </ng-template>